import { createSelector } from 'reselect';
export const makeSelectCurrentItemData = () => createSelector(state => state.cosmeticListed.data, state => state.cosmeticItemsConfigs.cosmeticConfigs, (cosmeticListed, cosmeticConfigs) => {
  if (!cosmeticListed) {
    return undefined;
  }

  const {
    listItem
  } = cosmeticListed || {};
  const listData = listItem.map(cosmetic => {
    if (!cosmetic) {
      return cosmetic;
    }

    const cosmeticInfo = cosmetic.cosmeticInfo ? cosmeticConfigs === null || cosmeticConfigs === void 0 ? void 0 : cosmeticConfigs[cosmetic.cosmeticInfo.typeId] : undefined;
    return cosmeticInfo ? { ...cosmetic,
      cosmeticRarity: cosmeticInfo.rarity,
      cosmeticType: cosmeticInfo.type,
      cosmeticName: cosmeticInfo.name
    } : cosmetic;
  });
  return {
    listItem: listData,
    timeout: (cosmeticListed === null || cosmeticListed === void 0 ? void 0 : cosmeticListed.timeout) || 0
  };
});